import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModuleRoutingModule } from './shared-module-routing.module';

import { TwoDigitDecimaNumberDirective } from '../../common/two-digit-decima-number.directive';
import { SafePipe } from '../../Helpers/safe.pipe';



@NgModule({
  declarations: [
    TwoDigitDecimaNumberDirective,
    SafePipe
  ],
  imports: [
    CommonModule,
    SharedModuleRoutingModule
  ],
  exports:[
    TwoDigitDecimaNumberDirective,
    SafePipe
  ]
})
export class SharedModuleModule { }
